<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<h2 waHeading="l" waText>Vert.x Event Bus &mdash; Code</h2>
				<p waBody="m" waColorText="quiet" waText>Publish from Java. Listen in Angular. No broker.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Server: publish via Vert.x event bus</div>
					<markdown [data]="mdContent_1183" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Server: custom WebSocket receiver</div>
					<markdown [data]="mdContent_1184" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
				<div class="code-block-wrapper">
					<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Client: listen in Angular &#40;TypeScript&#41;</div>
					<markdown [data]="mdContent_1185" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</div>
			</div>
		</div>
	</div>
</div>